import { amber, blue, brown, cyan, deepOrange, deepPurple, green, indigo, lightBlue, lightGreen, lime, orange, pink, purple, red, teal, yellow } from "@mui/material/colors";


const COLOR_BASES = [blue, orange, lightGreen, pink, cyan, brown, deepPurple, yellow, teal, red, amber, indigo, green, deepOrange, lightBlue, lime, purple];

export function getColor(hue: number, shade: any): string {
    return (COLOR_BASES[hue % COLOR_BASES.length] as any)[shade] as string;
}
